import { Fragment, type ReactNode } from 'react';

/**
 * The brand name, wine-coloured so it reads as a name wherever it appears in
 * copy. Always lower case. (The logo is the one place it isn't styled this way.)
 */
export function Brand() {
  return <span className="brand">reeve</span>;
}

/**
 * Renders a plain string with every occurrence of the brand name wrapped in the
 * brand style and normalised to lower case. Use for copy held as strings, such
 * as the FAQ data.
 */
export function brandify(text: string): ReactNode {
  return text.split(/(reeve)/gi).map((part, i) =>
    part.toLowerCase() === 'reeve' ? (
      <span className="brand" key={i}>
        reeve
      </span>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  );
}
